export const validateRelianceIPAHelper = (value, field, formik) => {
  const { name, arrayIndex } = field;
  const { values: formikValues } = formik;
  const Relationship = {
    Self: "345",
    Spouse: "320",
    Dependent_Daughter: "1989",
    Dependent_Son: "1988",
  };
  /** 
        1.Since sum insured of non earning spouse is more than 50 % of Self sum insured is not allowed.
        2.Sum Insured of Non Earning Spouse is Restricted to Table C for 50% 
        3.of Self Sum Insured and limited to 1 lakh
      */
  if (name === `primaryDetails[${arrayIndex}].SumInsured`) {
    if (!value) return null;

    const primaryDetails = formikValues?.primaryDetails;
    const currentDetail = primaryDetails?.[arrayIndex];

    if (!currentDetail) return null;

    const relationship = currentDetail.RelationshipWithProposerID;

    if (
      relationship === Relationship.Spouse &&
      currentDetail.IsEarningMember === "false"
    ) {
      const self = primaryDetails.find(
        (item) => item?.RelationshipWithProposerID === Relationship.Self
      );

      if (!self) return null;

      const selfSumInsured = self?.SumInsured;
      const maxSumInsured = selfSumInsured ? selfSumInsured * 0.5 : 0; // 50% of Self Sum Insured
      const restrictedSumInsured = Math.min(maxSumInsured, 100000); // Limited to 1 lakh

      if (value > restrictedSumInsured) {
        return "Sum Insured of non-earning spouse is restricted to Table C for 50% of Self Sum Insured and limited to 1 lakh";
      }
    } else if (
      /**
       * Sum Insured of earning spouse cannot exceed Self Sum Insured
       */
      relationship === Relationship.Spouse &&
      currentDetail.IsEarningMember === "true"
    ) {
      const self = primaryDetails.find(
        (item) => item?.RelationshipWithProposerID === Relationship.Self
      );

      if (!self) return null;

      const selfSumInsured = self?.SumInsured;
      const maxSumInsured = selfSumInsured || 0; // Self Sum Insured
      if (value > maxSumInsured) {
        return "Sum Insured of earning spouse cannot exceed Self Sum Insured";
      }
    }
    /** 
        4. Since sum insured of child  is more than 25 % of Self sum insured is not allowed.
        5. Since table C is selected for child is not allowed
        6. Sum Insured of Child is Restricted to Table B for 25% of Self Sum Insured and limited to 50000
       */
    if (
      relationship === Relationship.Dependent_Daughter ||
      relationship === Relationship.Dependent_Son
    ) {
      const self = primaryDetails.find(
        (item) => item?.RelationshipWithProposerID === Relationship.Self
      );

      if (!self) return null;

      const selfSumInsured = self?.SumInsured;
      const maxSumInsured = selfSumInsured ? selfSumInsured * 0.25 : 0; // 25% of Self Sum Insured
      const restrictedSumInsured = Math.min(maxSumInsured, 50000); // Limited to 50,000

      if (value > restrictedSumInsured) {
        return "Sum Insured of child is restricted to Table B for 25% of Self Sum Insured and limited to 50,000";
      }
    }
  }

  return null;
};
